/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Settings_Billing_Cancel_DescriptionInputs */

const en_settings_billing_cancel_description = /** @type {(inputs: Settings_Billing_Cancel_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to cancel your ${i?.plan} subscription? You'll keep access until the end of the current billing period.`)
};

const zh_settings_billing_cancel_description = /** @type {(inputs: Settings_Billing_Cancel_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`确定要取消「${i?.plan}」订阅吗？你可以使用到当前计费周期结束。`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to cancel your {plan} subscription? You'll keep access until the end of the current billing period." |
*
* @param {Settings_Billing_Cancel_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_description = /** @type {((inputs: Settings_Billing_Cancel_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_cancel_description(inputs)
	return zh_settings_billing_cancel_description(inputs)
});
export { settings_billing_cancel_description as "settings.billing.cancel_description" }